export const styleVar = {
  primary500: "#ff0101",

  neutral100: "#fbfbfb",
  neutral200: "#dedede",
  neutral400: "#9b9eac",
  neutral500: "#74798c",
  neutral800: "#2b2d30",
  neutral900: "#020203",
};
